module.exports = __webpack_public_path__ + "static/media/page-logo.803e0d75.png";